import axios from '../axios-on-rails';

export default class CompanyNotes {
  new(e) {
    axios.get(Routes.new_companies_candidate_note_path(gon.locale),
      { params: { member_id: $(e).data('member-id') }})
      .then(response => $('#noteInput').html(response.data))
  }

  cancel() {
    $('#noteInput').html('')
  }

  edit(e) {
    const noteId = $(e).data('id');
    axios.get(Routes.edit_companies_candidate_note_path(gon.locale, noteId))
      .then(response => $('#noteInput').html(response.data))
  }

  request(e) {
    const form = $(e).closest('form');
    const str = form.find('#companies_candidate_note_notes').val();
    if (str == "" || str == null) {
      alert(gon.alert_text);
    } else {
      const method = form.serializeArray().find(attr => attr['name'] === '_method') || {value: 'post'};
      axios({
        method: method.value,
        url: form.attr('action'),
        data: form.serialize()
      }).then(_ => location.reload())
    }
  }
}
